import { SVGProps, Ref, forwardRef } from 'react';

export const GripSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="m14.273 21.344 7.07-7.071L20.072 13 13 20.071z" fill="currentColor" />
            <path d="M18.85 22 22 18.85l-1.273-1.274-3.15 3.151z" fill="currentColor" />
        </g>
    </svg>
));
GripSize24Glyph.displayName = 'GripSize24Glyph';
